import i18n from '@/translations/i18n';
import VueI18n from 'vue-i18n';

export default function(value: string, ...args: any[]): VueI18n.TranslateResult {
  return i18n.t(value, ...args);
}
